import { render, staticRenderFns } from "./PreLogin.vue?vue&type=template&id=22da70b0"
import script from "./PreLogin.vue?vue&type=script&lang=js"
export * from "./PreLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports